<template>
    <Modal v-model="updateShow" width="408" class-name="vertical-update-modal" @on-visible-change="updateHide">
        <div class="update-container">
            <div class="update-header">
                <div class="line"></div>
                <div class="update-text">查看更新</div>
            </div>

            <div class="update-content-text">
               <div class="item-info" v-for="content in contents">
                   <div class="title">
                       新增{{content.name}}
                   </div>
                   <div v-for="subItem in content.items">
                       <div class="item-name">
                           <span class="one one-dot"></span>
                           <a class="name" :href="subItem.href" target="_blank">{{subItem.title}}</a>
                       </div>
                       <pre class="item-des" v-html="subItem.desc"></pre>
                   </div>
               </div>
            </div>
            <div class="gery-area"></div>

            <div class="bottom-btn">
                <button @click="updateHide()">
                    我知道了
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
    export default {
        name: "UpdateMessage",
        props: {updateShow: Boolean, title: String, icon: String, contents: Array},
        methods: {
            updateHide(flag) {
                if (flag) {
                    return
                }
                this.$emit('updateHide', false)
            }
        }
    }
</script>

<style lang="scss">
    .vertical-update-modal .ivu-modal-content {
        background: inherit;
        box-shadow: none;

        .ivu-modal-close {
            display: none;
        }

        .close-icon {
            color: white;
            width: 28px;
            z-index: 100;
            position: relative;
            left: 50%;
            top: 20px;
            cursor: pointer;

            &:hover {
                color: #ED6C00;
            }
        }

        .ivu-modal-footer {
            display: none;
        }

        .update-container {
            position: relative;
            width: 480px;
            height: 600px;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
            border-radius: 9px;
            background: #ffffff;

            .update-header {
                display: block;
                height: 57px;
                position: relative;
                padding-top: 40px;
                .line{
                    border-bottom:1px solid #E3E3E3;
                    width:220px ;
                    margin: auto;
                }
                .update-text{
                    position: absolute;
                    margin: auto;
                    z-index: 10;
                    left: 0;
                    right: 0;
                    top:25px;
                    display: inline-block;
                    width: 100px;
                    background: white;
                    height: 28px;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 28px;
                    text-align: center;
                    color: #ED6C00;
                }
            }

            .update-content-text {
                &::-webkit-scrollbar {
                    display: none;
                }

                margin: auto;
                margin-top: 20px;
                left: 0;
                right: 0;
                position: absolute;
                width: 379px;
                height: 452px;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 200%;
                overflow: auto;
                color: #000000;
                padding-bottom: 20px;
                .item-info{
                    margin-bottom: 20px;
                    .title{
                        font-style: normal;
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 200%;
                        color: #000000;

                    }
                    .item-name{
                        padding: 2px 20px;
                        .one{
                            font-size: 12px;
                            position: relative;
                            top:2px
                        }
                        a{
                            color:#000000 ;
                            text-decoration: underline;
                            &:hover{
                                color: #ed6c00;
                            }
                        }
                    }
                    .item-des{
                        color: #666666;
                        padding-left: 20px;
                        white-space: pre-wrap!important;
                        word-wrap: break-word!important;
                        *white-space:normal!important;
                    }
                }
            }

            .gery-area {
                position: absolute;
                width: 480px;
                height: 20px;
                bottom: 80px;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.02) 100%);
            }

            .bottom-btn {
                text-align: center;
                position: absolute;
                bottom: 8px;
                height: 70px;
                background: #FFFFFF;
                border-radius: 0px 0px 9px 9px;
                width: 100%;
                button {
                    outline: none;
                    cursor: pointer;
                    width: 170px;
                    height: 36px;
                    line-height: 30px;
                    color: #ED6C00;
                    font-size: 13px;
                    background: white;
                    border-radius: 18px;
                    display: inline-block;
                    margin-top: 17px;
                    border: 1px solid #E3E3E3;
                    .one {
                        color: #ED6C00;
                        font-size: 18px;
                        position: relative;
                        top: 3px
                    }
                }

            }

        }
    }

    .vertical-update-modal {
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal {
            top: 0;
        }
    }

</style>
